import type { Address } from '@patrianna/shared-patrianna-types/store/UserModule'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { KycState, KycStatus } from './types'

export const initialState: KycState = {
  status: null,
  info: null,
  kyc: true,
  isLoading: false,
}

export const kycSlice = createSlice({
  name: 'kyc',
  initialState,
  reducers: {
    setKycData: (
      state,
      action: PayloadAction<{
        status: KycStatus
        info: Partial<Address> | null
        kyc: boolean
      }>,
    ) => {
      state.status = action.payload.status
      state.info = action.payload.info
      state.kyc = action.payload.kyc
    },

    setKycStatus: (state, action: PayloadAction<{ status: KycStatus }>) => {
      state.status = action.payload.status
    },

    setKycLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
      state.isLoading = action.payload.isLoading
    },

    setKyc: (state, action: PayloadAction<{ kyc: boolean }>) => {
      state.kyc = action.payload.kyc
    },

    clearKyc: () => initialState,
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof kycSlice.actions>>

export const { actions } = kycSlice
